export const loadScripts = async () => {
  await import('alpinejs')
}